export enum TextLeadingDistribution {
  proportional,
  even,
}
